import React, { useEffect } from 'react'
import { useSelector } from "react-redux";

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container } from '@mui/material';

function Dashboard() {

    const auth = useSelector((state) => state.auth);

    useEffect(() => {
        document.title = 'Inicio';
    }, [])

    return (
        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Inicio</Typography>
            </Box>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                {cards.map((card, i) => {
                    if (card.auth.includes(auth.user.rol)) {
                        return (
                            <Grid item key={i} xs={12} sm={6} md={4}>
                                <CustomCard
                                    title={card.title}
                                    to={card.to}
                                    button={card.button}
                                    cardIco={card.cardIco}
                                    text={card.text}
                                />
                            </Grid>
                        )
                    }
                    return null;
                })}
            </Grid>
            <br></br>
        </Container>
    )
}

const cards = [
    {
        title: "Inventario",
        text: "Control de entradas, salidas y existencias de refacciones y productos. Vales de salida de material.",
        button: "Inventario",
        cardIco: "fad fa-inventory fa-3x",
        to: "/inventario",
        auth: ['Admin', 'Vendedor', 'Tecnico', 'Almacen', 'Secretaria', 'Ayudante']
    },
    {
        title: "Cotizaciones y ventas",
        text: "Crea y edita cotizaciones, ordenes de compra y ventas.",
        button: "Cotizaciones y ventas",
        cardIco: "fad fa-file-invoice fa-3x",
        to: "/cotizaciones",
        auth: ['Admin', 'Vendedor', 'Ayudante']
    },
    {
        title: "Clientes y proveedores",
        text: "Agregar, editar o eliminar clientes y proveedores.",
        button: "Clientes y proveedores",
        cardIco: "fad fa-users fa-3x",
        to: "/clientes",
        auth: ['Admin', 'Vendedor', 'Almacen', 'Secretaria', 'Ayudante']
    },
    // {
    //     title: "Control de stock",
    //     text: "Confuguración de stock mínimo y máximo.",
    //     button: "Stock",
    //     cardIco: "fad fa-file-signature fa-3x",
    //     to: "/stock",
    //     auth: ['Admin', 'Almacen', 'Secretaria', 'Ayudante']
    // },
    {
        title: "Ubicaciones de almacén",
        text: "Agregar, editar o eliminar ubicaciones de almacén.",
        button: "Almacenes",
        cardIco: "fad fa-warehouse-alt fa-3x",
        to: "/almacenes",
        auth: ['Admin', 'Almacen']
    },
    {
        title: "Informes y análisis",
        text: "Generar informes y análisis de ventas, compras y existencias.",
        button: "Informes y análisis",
        cardIco: "fad fa-analytics fa-3x",
        to: "/informes",
        auth: ['Admin', 'Secretaria', 'Almacen', 'Ayudante']
    },
    {
        title: "Gestor de Imágenes",
        text: "Cargar, visualizar y eliminar imágenes de productos",
        button: "Imágenes",
        cardIco: "fad fa-images fa-3x",
        to: "/imagenes",
        auth: ['Admin', 'Almacen', 'Vendedor', 'Secretaria', 'Ayudante']
    },
    {
        title: "Gastos",
        text: "Gestión de los gastos de la empresa",
        button: "Gastos",
        cardIco: "fad fa-envelope-open-dollar fa-3x",
        to: "/gastos",
        auth: ['Admin']
    },
    {
        title: "Facturas",
        text: "Control de facturas emitidas",
        button: "Facturas",
        cardIco: "fad fa-file-invoice-dollar fa-3x",
        to: "/facturas",
        auth: ['Admin']
    },

]

export default Dashboard;